// 导入所有内置插件
import LiaoFaqCardPlugin from './LiaoFaqCardPlugin.vue';
import LiaoFormPlugin from './LiaoFormPlugin.vue';
import LiaoListPlugin from './LiaoListPlugin.vue';
import LiaoImageCardPlugin from './LiaoImageCardPlugin.vue';
import LiaoActionsPlugin from './LiaoActionsPlugin.vue';
import LiaoVotePlugin from './LiaoVotePlugin.vue';
import LiaoInfoPlugin from './LiaoInfoPlugin.vue';
import LiaoProgressPlugin from './LiaoProgressPlugin.vue';
import LiaoStatsPlugin from './LiaoStatsPlugin.vue';
import LiaoTimelinePlugin from './LiaoTimelinePlugin.vue';
import LiaoMediaCarouselPlugin from './LiaoMediaCarouselPlugin.vue';
import LiaoPluginDebugger from './LiaoPluginDebugger.vue';

// 导出插件
export {
  LiaoFaqCardPlugin,
  LiaoFormPlugin,
  LiaoListPlugin,
  LiaoImageCardPlugin,
  LiaoActionsPlugin,
  LiaoVotePlugin,
  LiaoInfoPlugin,
  LiaoProgressPlugin,
  LiaoStatsPlugin,
  LiaoTimelinePlugin,
  LiaoMediaCarouselPlugin,
  LiaoPluginDebugger
};

// 默认导出
export default {
  LiaoFaqCardPlugin,
  LiaoFormPlugin,
  LiaoListPlugin,
  LiaoImageCardPlugin,
  LiaoActionsPlugin,
  LiaoVotePlugin,
  LiaoInfoPlugin,
  LiaoProgressPlugin,
  LiaoStatsPlugin,
  LiaoTimelinePlugin,
  LiaoMediaCarouselPlugin,
  LiaoPluginDebugger
}; 